import { Skeleton } from "@progress/kendo-react-indicators";

import "./skeleton.scss";

export const SkeletonHeaderCell = (props) => (
  <th className="skeleton-cell headerCustomCell" data-testid={`${props.index !== 0 ? "text-skeleton-column" : ""}`}>
      <Skeleton
        shape="text"
        className="skeleton-text"
        animation={{ type: "wave" }}
        data-testid="text-skeleton"
      />
  </th>
);